/**
 * Mock Telegram WebApp для разработки
 * Позволяет тестировать приложение в браузере без Telegram
 */

// Моковый пользователь (твой реальный ID из продакшена)
const MOCK_USER = {
  id: 517718894,
  first_name: 'Юрий',
  last_name: 'Иовков',
  username: 'yurii_iovkov',
  language_code: 'ru',
  is_premium: false,
  allows_write_to_pm: true,
}

// Генерируем мок init data
const generateMockInitData = () => {
  const user = encodeURIComponent(JSON.stringify(MOCK_USER))
  const authDate = Math.floor(Date.now() / 1000)
  const queryId = 'DEV_' + Math.random().toString(36).substring(7)

  // Фейковый hash для dev режима
  const hash = 'dev_mode_hash_' + Math.random().toString(36).substring(7)

  return `query_id=${queryId}&user=${user}&auth_date=${authDate}&hash=${hash}`
}

// Mock Telegram WebApp API
export const mockTelegramWebApp = {
  initData: generateMockInitData(),
  initDataUnsafe: {
    query_id: 'DEV_QUERY_ID',
    user: MOCK_USER,
    auth_date: Math.floor(Date.now() / 1000),
    hash: 'dev_mode_hash',
  },
  version: '6.0',
  platform: 'web',
  colorScheme: 'light' as const,
  themeParams: {
    bg_color: '#ffffff',
    text_color: '#000000',
    hint_color: '#999999',
    link_color: '#2481cc',
    button_color: '#2481cc',
    button_text_color: '#ffffff',
    secondary_bg_color: '#f4f4f5',
    section_bg_color: '#ffffff',
  },
  isExpanded: true,
  viewportHeight: 600,
  viewportStableHeight: 600,
  headerColor: '#ffffff',
  backgroundColor: '#ffffff',
  isClosingConfirmationEnabled: false,
  isVerticalSwipesEnabled: true,
  BackButton: {
    isVisible: false,
    onClick: (_callback: () => void) => {
      console.log('[Mock Telegram] BackButton.onClick registered')
    },
    offClick: (_callback: () => void) => {
      console.log('[Mock Telegram] BackButton.offClick registered')
    },
    show: () => {
      console.log('[Mock Telegram] BackButton.show()')
    },
    hide: () => {
      console.log('[Mock Telegram] BackButton.hide()')
    },
  },
  MainButton: {
    text: 'CONTINUE',
    color: '#2481cc',
    textColor: '#ffffff',
    isVisible: false,
    isActive: true,
    isProgressVisible: false,
    setText: (text: string) => {
      console.log('[Mock Telegram] MainButton.setText:', text)
    },
    onClick: (_callback: () => void) => {
      console.log('[Mock Telegram] MainButton.onClick registered')
    },
    offClick: (_callback: () => void) => {
      console.log('[Mock Telegram] MainButton.offClick registered')
    },
    show: () => {
      console.log('[Mock Telegram] MainButton.show()')
    },
    hide: () => {
      console.log('[Mock Telegram] MainButton.hide()')
    },
    enable: () => {
      console.log('[Mock Telegram] MainButton.enable()')
    },
    disable: () => {
      console.log('[Mock Telegram] MainButton.disable()')
    },
    showProgress: (leaveActive: boolean) => {
      console.log('[Mock Telegram] MainButton.showProgress:', leaveActive)
    },
    hideProgress: () => {
      console.log('[Mock Telegram] MainButton.hideProgress()')
    },
    setParams: (params: any) => {
      console.log('[Mock Telegram] MainButton.setParams:', params)
    },
  },
  HapticFeedback: {
    impactOccurred: (style: 'light' | 'medium' | 'heavy' | 'rigid' | 'soft') => {
      console.log('[Mock Telegram] HapticFeedback.impactOccurred:', style)
    },
    notificationOccurred: (type: 'error' | 'success' | 'warning') => {
      console.log('[Mock Telegram] HapticFeedback.notificationOccurred:', type)
    },
    selectionChanged: () => {
      console.log('[Mock Telegram] HapticFeedback.selectionChanged()')
    },
  },
  ready: () => {
    console.log('[Mock Telegram] WebApp.ready()')
  },
  expand: () => {
    console.log('[Mock Telegram] WebApp.expand()')
  },
  close: () => {
    console.log('[Mock Telegram] WebApp.close()')
  },
  enableClosingConfirmation: () => {
    console.log('[Mock Telegram] WebApp.enableClosingConfirmation()')
  },
  disableClosingConfirmation: () => {
    console.log('[Mock Telegram] WebApp.disableClosingConfirmation()')
  },
  enableVerticalSwipes: () => {
    console.log('[Mock Telegram] WebApp.enableVerticalSwipes()')
  },
  disableVerticalSwipes: () => {
    console.log('[Mock Telegram] WebApp.disableVerticalSwipes()')
  },
  showPopup: (params: any, callback?: (id: string) => void) => {
    console.log('[Mock Telegram] WebApp.showPopup:', params)
    if (callback) callback('ok')
  },
  showAlert: (message: string, callback?: () => void) => {
    console.log('[Mock Telegram] WebApp.showAlert:', message)
    alert(message)
    if (callback) callback()
  },
  showConfirm: (message: string, callback?: (confirmed: boolean) => void) => {
    console.log('[Mock Telegram] WebApp.showConfirm:', message)
    const confirmed = confirm(message)
    if (callback) callback(confirmed)
  },
  openLink: (url: string, options?: { try_instant_view?: boolean }) => {
    console.log('[Mock Telegram] WebApp.openLink:', url, options)
    window.open(url, '_blank')
  },
  openTelegramLink: (url: string) => {
    console.log('[Mock Telegram] WebApp.openTelegramLink:', url)
    window.open(url, '_blank')
  },
  openInvoice: (url: string, callback?: (status: string) => void) => {
    console.log('[Mock Telegram] WebApp.openInvoice:', url)
    if (callback) callback('paid')
  },
  sendData: (data: string) => {
    console.log('[Mock Telegram] WebApp.sendData:', data)
  },
  switchInlineQuery: (query: string, chooseChatTypes?: string[]) => {
    console.log('[Mock Telegram] WebApp.switchInlineQuery:', query, chooseChatTypes)
  },
  readTextFromClipboard: (callback?: (text: string) => void) => {
    console.log('[Mock Telegram] WebApp.readTextFromClipboard()')
    if (callback) callback('')
  },
  requestWriteAccess: (callback?: (granted: boolean) => void) => {
    console.log('[Mock Telegram] WebApp.requestWriteAccess()')
    if (callback) callback(true)
  },
  requestContact: (callback?: (shared: boolean) => void) => {
    console.log('[Mock Telegram] WebApp.requestContact()')
    if (callback) callback(false)
  },
  invokeCustomMethod: (method: string, params: any, callback?: (error: any, result: any) => void) => {
    console.log('[Mock Telegram] WebApp.invokeCustomMethod:', method, params)
    if (callback) callback(null, {})
  },
}

// Инициализация мока в dev режиме
export const initMockTelegram = () => {
  if (import.meta.env.VITE_DEV_MODE === 'true') {
    console.log('🔧 Development mode: using mock Telegram WebApp')
    console.log('👤 Mock user:', MOCK_USER)

    // Добавляем мок в window
    ;(window as any).Telegram = {
      WebApp: mockTelegramWebApp,
    }

    // Вызываем ready автоматически
    mockTelegramWebApp.ready()
    mockTelegramWebApp.expand()
  }
}
